import { useState } from 'react';
import { Button } from '@mui/material';
import * as Yup from 'yup';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { BuildingOtherForm } from '../project-forms/building-other.form';
import { Building } from '../../../models/building';
import { ApiResponse } from '../../../models/api-response';
import { useLoadData } from '../../../hooks/useLoadData';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';
import SampleFileForDownload from './sample-file-for-download';

interface CreateBuildingOtherDataButtonProps {
  projectID: string;
  building: Building;
  syncWithDux: any;
  onBuildingOtherDataCreated: (data: any) => void;
  projectTypeValue: any;
  existingData: any;
  projectStreet?: string;
  projectCommunityType?: string;
}

export const CreateBuildingOtherDataButton = ({
  projectID,
  building,
  syncWithDux,
  projectTypeValue,
  existingData,
  projectStreet,
  projectCommunityType,
  onBuildingOtherDataCreated,
}: CreateBuildingOtherDataButtonProps) => {
  const [newBuilding, setNewOtherData] = useState<any>();

  // const isProjectTypeRES = projectTypeValue === "RES";
  const isProjectTypeRES = true;

  const validationSchema = Yup.object().shape({
    otherData: Yup.object().shape({
      commonAreaName: Yup.string().required('Required'),
      commonAreaFloorNo: Yup.string().required('Floor number is required'),
      // jobNumber: Yup.string().required('Job number is required'),
      jobsite: Yup.string().required('Jobsite is required'),
      lotType: isProjectTypeRES ? Yup.string().required('Lot type is required') : Yup.string().notRequired(),
      address: Yup.string().required('Address is required'),
    }),
  });

  const handleDialogClose = () => {
    setNewOtherData(undefined);
  };

  const handleAddBuildingFloor = () => {
    // setNewOtherData({ floorName: '', otherData.jobsite: '' });
    setNewOtherData({
      otherData: {
        commonAreaName: '',
        commonAreaFloorNo: '',
        jobNumber: '',
        jobsite: '',
        address: '',
        proctorResult: null,
        // createWO: false,
        // syncWithDUX: false,
        buildingPermit: '',
        lotType: '',
      },
    });
  };

  const transformData = (data: any) => {
    return {
      unitName: data.unitName,
      jobNumber: data.jobNumber,
      jobsite: data?.jobsite,
      commonAreaFloorNo: data?.commonAreaFloorNo,
      commonAreaName: data?.commonAreaName,
      address: data.address,
      proctorResult: !data.proctorResult
        ? null
        : {
            proctorResultsID: data?.proctorResult?.proctorResultsID,
            unitID: 0,
            proctorFileName: data?.proctorResult?.proctorFileName,
          },

      // createWO: data.createWO,
      // syncWithDUX: data.syncWithDUX,
      buildingPermit: data.buildingPermit,
      lotType: data.lotType,
      squareFeet: data.squareFeet,
    };
  };

  const formatSubmitData = (data: any) => {
    const { buildingID, buildingName } = building;

    const transformDatas = transformData(data.otherData);

    return {
      projectID,
      buildingID,
      buildingName,
      commonAreaFloorNo: transformDatas?.commonAreaFloorNo,
      commonAreaName: transformDatas?.commonAreaName,
      address: transformDatas?.address,
      jobNumber: transformDatas?.jobNumber,
      proctorResult: transformDatas?.proctorResult,
      unitName: transformDatas?.unitName,
      jobsite: transformDatas?.jobsite,
      lotType: transformDatas?.lotType,
      squareFeet: transformDatas?.squareFeet,

      // createWO: transformDatas?.createWO,
      // syncWithDUX: transformDatas?.syncWithDUX,
      buildingPermit: transformDatas?.buildingPermit,
    };
  };

  const { data, isLoading } = useLoadData<ApiResponse<any>>(
    projectsApiKeyStore.generateLotNameByID(projectID, !!newBuilding)
  );

  return (
    <>
      <Button
        className="btn btn-primary"
        variant="text"
        sx={{ p: 0, m: 0, mr: 1, mb: 1 }}
        onClick={handleAddBuildingFloor}
      >
        Add Other
      </Button>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_UNIT]}>
          <SampleFileForDownload />
        </GuardedComponent>
      </div>

      {newBuilding && (
        <SaveHookFormDialog
          title={'CREATE OTHER'}
          config={{
            saveConfig: projectsApiKeyStore.createCommonArea(),
          }}
          data={newBuilding}
          onClose={handleDialogClose}
          onSaveCompleted={onBuildingOtherDataCreated}
          formatSubmitdata={formatSubmitData}
          size="xl"
          yupSchema={validationSchema}
        >
          <BuildingOtherForm
            name="otherData"
            syncWithDux={syncWithDux}
            projectID={projectID}
            data={data}
            projectTypeValue={projectTypeValue}
            existingData={existingData}
            projectStreet={projectStreet}
            projectCommunityType={projectCommunityType}
          />
        </SaveHookFormDialog>
      )}
    </>
  );
};
